export enum FancyShareAction {
  Share = 'Share',
  DownloadImage = 'DownloadImage',
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',

  ActiveEdit = 'ActiveEdit',
  CancelEdit = 'CancelEdit',
}

export const FancyShareActionText = {
  [FancyShareAction.Share]: '공유하기',
  [FancyShareAction.DownloadImage]: '이미지 다운로드',
  [FancyShareAction.Create]: '게시물 추가',
  [FancyShareAction.Update]: '게시물 편집',
  [FancyShareAction.Delete]: '게시물 삭제',
  [FancyShareAction.ActiveEdit]: '게시물 편집',
  [FancyShareAction.CancelEdit]: '게시물 편집 취소',
};

export enum FancyShareTextAlign {
  center = 'center',
  left = 'left',
}

export const FancyShareTextAlignString = { [FancyShareTextAlign.left]: '왼쪽', [FancyShareTextAlign.center]: '가운데' };
